import { ComposedTheme } from '@glu/theming';

/* istanbul ignore file */
export default ({ palette, typography }: ComposedTheme) => ({
  checkboxLabel: {
    // @Spread - to be split out in GLU-7538
    ...typography.text,
    // @theming labelText: Checkbox label color, type: color
    color: palette.text.dark,
    // @theming labelText: Checkbox label display, type: string
    display: 'flex',
    // @theming labelText: Checkbox label font size, type: pixel
    fontSize: 14,
    // @theming labelText: Checkbox label margin left, type: pixel
    marginLeft: 5,
  },
  checkboxRadio: {
    // @theming labelText: Checkbox border color, type: color
    borderColor: palette.colors.doveGray,
    /* @theming labelText: Checkbox check color, type: color,
     backgroundColor: formComponents.checkboxRadio.selectedColor
    */
    checkColor: palette.text.light,
    dark: {
      // @theming labelText: Dark mode checkbox border color, type: color
      borderColor: palette.text.light,
      /* @theming labelText: Dark mode checkbox check color, type: color,
      backgroundColor: formComponents.checkboxRadio.dark.selectedColor
      */
      checkColor: palette.colors.pickledBluewood,
      // @theming labelText: Dark mode checkbox selected color, type: color
      selectedColor: palette.text.light,
    },
    // @theming labelText: Checkbox selected color, type: color
    selectedColor: palette.colors.lochmara,
    // @theming labelText: Checkbox shadow color, type: color
    shadowColor: palette.colors.doveGray,
  },
  // @theming labelText: Checkbox icon display, type: string
  checkboxRadioSvgDisplay: 'inline-block',
  container: {
    // @theming labelText: Container margin bottom, type: pixel
    marginBottom: 20,
  },
  dark: {
    // @theming labelText: Dark mode input color, type: color
    color: palette.text.light,
    error: {
      // @theming labelText: Dark mode error border color, type: color
      borderColor: palette.colors.monaLisa,
      // @theming labelText: Dark mode error color, type: color
      color: palette.colors.monaLisa,
    },
    warning: {
      // @theming labelText: Dark mode warning border color, type: color
      borderColor: palette.colors.yellowOrange,
      // @theming labelText: Dark mode warning color, type: color
      color: palette.text.light,
      // @theming labelText: Dark mode warning icon color, type: color
      iconColor: palette.colors.yellowOrange,
      // @theming labelText: Dark mode warning message color, type: color
      messageColor: palette.text.light,
    },
  },
  // @Unused - see GLU-7538
  disabled: {},
  error: {
    // @theming labelText: Error border color, type: color
    borderColor: palette.form.error,
    // @theming labelText: Error color, type: color
    color: palette.form.error,
    // @theming labelText: Error font family, type: fontFamily
    fontFamily: typography.fontFamily,
    // @theming labelText: Error font size, type: pixel
    fontSize: 12,
    // @theming labelText: Error font weight, type: fontWeight
    fontWeight: typography.fontWeight,
    iconDisplay: 'inherit',
  },
  helpText: {
    // @theming labelText: Help text color, type: color
    color: palette.text.midGray,
    dark: {
      // @theming labelText: Dark mode help text color, type: color
      color: palette.text.light,
    },
  },
  // CheckboxRadio
  // @Unused - see GLU-7538
  hiddenCheckbox: {
    clip: 'rect(1px, 1px, 1px, 1px)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    width: 1,
  },
  input: {
    // @theming labelText: Input background color, type: color
    backgroundColor: palette.background,
    // @theming labelText: Input border, type: string
    border: `1px solid ${palette.form.border}`,
    // @theming labelText: Input border radius, type: pixel
    borderRadius: 2,
    // @theming labelText: Input color, type: color, backgroundColor: formComponents.input.backgroundColor
    color: palette.text.dark,
    dark: {
      // @theming labelText: Dark mode input background color, type: color
      backgroundColor: 'inherit',
    },
    /* @theming labelText: Dark mode input color, type: color,
    backgroundColor: formComponents.input.dark.backgroundColor
    */
    darkColor: palette.text.light,
    // @theming labelText: Dark mode input focus color, type: color
    darkFocusColor: palette.primary.light,
    // @theming labelText: Input focus color, type: color
    focusColor: palette.focus.normal,
    // @theming labelText: Input font family, type: fontFamily
    fontFamily: typography.fontFamily,
    // @theming labelText: Input font size, type: pixel
    fontSize: 14,
    // @theming labelText: Input font weight, type: fontWeight
    fontWeight: typography.fontWeight,
    // @theming labelText: Input height, type: pixel
    height: 34,
    // @theming labelText: Input padding, type: pixel
    padding: [6, 10],
    // @theming labelText: Dark mode input placeholder color, type: color
    placeholder: palette.accent,
    // @theming labelText: Text area height, type: pixel
    textareaHeight: 60,
  },
  label: {
    // @Spread - to be split out in GLU-7538
    ...typography.label,
    // @theming labelText: Label color, type: color
    color: palette.text.midGray,
    // @theming labelText: Label margin, type: pixel
    margin: [0, 0, 4],
  },
  numberFirstButton: {
    // @Unused - see GLU-7538
    borderRadius: [0, 2, 0, 0],
  },
  numberInput: {
    // @theming labelText: Number input border radius, type: pixel
    borderRadius: [2, 0, 0, 2],
    // @theming labelText: Dark mode disabled number input button background color, type: color
    buttonBackGroundColorDark: palette.colors.pickledBluewood,
    // @theming labelText: Number input button color, type: color
    buttonColor: palette.primary.normal,
    // @theming labelText: Dark mode number input button color, type: color
    buttonColorDark: palette.info,
  },
  numberLastButton: {
    // @Unused - see GLU-7538
    borderRadius: [0, 0, 2, 0],
  },
  // @theming labelText: Optional text font family, type: fontFamily
  optionalSpanFontFamily: typography.fontFamily,
  // @theming labelText: Optional text font size, type: pixel
  optionalSpanFontSize: 12,

  // SelectBase
  select: {
    caret: {
      // This is a how legacy themed the caret, not relevant to Ash
      display: 'none',
    },
    // @theming labelText: Select caret display, type: string
    caretIcon: 'block',
    // @theming labelText: Select caret right position, type: pixel
    caretRight: 10,
    // @theming labelText: Select caret top position, type: pixel
    caretTop: 9,
    // @theming labelText: Dark mode select focus color, type: color
    darkFocusColor: palette.focus.dark,
    // @theming labelText: Dark mode select caret fill, type: color
    darkIconFill: palette.text.light,
    // @Unused - see GLU-7538
    darkOptionBackground: palette.primary.darkBackground,
    // @Unused - see GLU-7538
    darkOptionColor: palette.text.light,
    // @theming labelText: Select focus color, type: color
    focusColor: palette.focus.normal,
    // @theming labelText: Select caret fill, type: color
    iconFill: palette.text.dark,
    // @Unused - see GLU-7538
    optionBackground: palette.background,
    // @Unused - see GLU-7538
    optionColor: palette.text.dark,
    // @theming labelText: Select padding, type: pixel
    padding: [9, 30, 9, 10],
  },
  warning: {
    // @theming labelText: Warning border color, type: color
    borderColor: palette.colors.yellowOrange,
    // @theming labelText: Warning color, type: color
    color: palette.text.midGray,
    // @theming labelText: Warning icon color, type: color
    iconColor: palette.colors.yellowOrange,
    // @theming labelText: Warning message color, type: color
    messageColor: palette.text.dark,
  },
});
